export default __webpack_public_path__ + "static/media/chooseLangModalBC4.fdf3a1ed.png";